let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jwlH1")).then(() => parcelRequire('a0GzC'));